<template>
  <b-card no-body>
    <b-card-body class="text-right">
      <b-button
        to="brands/add"
        variant="primary"
      ><FeatherIcon icon="PlusIcon" />
        Ekle</b-button>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
    >
      <template #cell(title)="data">
        {{ data.item.title }}
      </template>
      <template #cell(control)="data">
        <b-button
          :to="'/brands/edit/' + data.item.id"
          variant="outline-primary"
          size="sm"
        >
          Güncelle
        </b-button>
      </template>
    </b-table>
    <b-card-footer><b-pagination
      v-model="currentPage"
      :total-rows="dataCount"
      :per-page="perPage"
      first-number
      last-number
      prev-class="prev-item"
      next-class="next-item"
    >
      <template #prev-text>
        <feather-icon
          icon="ChevronLeftIcon"
          size="18"
        />
      </template>
      <template #next-text>
        <feather-icon
          icon="ChevronRightIcon"
          size="18"
        />
      </template>
    </b-pagination></b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BTable, BCardFooter, BPagination, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BCardFooter,
    BPagination,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'title',
          label: 'Marka',
        },
        {
          key: 'control',
          label: 'Kontrol',
          thStyle: { width: '140px' },
        },
      ],
      dataQuery: {
        select: [
          'brands.id AS id',
          'brands.title AS title',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['brands/getBrands']
    },
    dataCount() {
      return this.$store.getters['brands/getBrandsCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('brands/brandsList', this.dataQuery)
    },
  },
}
</script>
